(ns nl.mediquest.questionnaire-frontend.effects
  (:require
   [nl.mediquest.ui.css :refer [inject-styles!]]
   [re-frame.core :as re-frame]))

(re-frame/reg-fx
 ::set-survey-locale
 (fn [{:keys [survey-model locale]}]
   (when (and survey-model locale)
     (set! (.-locale survey-model) (name locale)))))

(defn- inject-styling! [styles]
  (when-let [color-scheme (:color-scheme styles)]
    (inject-styles! :css.theme/styles [[":root" color-scheme]]))
  (when-let [footer-logo (:footer/logo styles)]
    (-> "footer-img" js/document.getElementById .-src (set! footer-logo))))

(re-frame/reg-fx
 ::styling
 (fn [{:keys [styles]}]
   (inject-styling! styles)))

(re-frame/reg-fx
 ::call-fn
 (fn [f]
   (f)))
